import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { Meta } from '@angular/platform-browser';


import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomepageComponent } from './homepage/homepage.component';
import { AboutComponent } from './about/about.component';
import { EducomComponent } from './educom/educom.component';
import { TimelineComponent } from './timeline/timeline.component';
import { ContactusComponent } from './contactus/contactus.component';
import { EmploymentComponent } from './employment/employment.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CarouselComponent } from './carousel/carousel.component';
import { FooterComponent } from './footer/footer.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MobilityComponent } from './mobility/mobility.component';
import { DailyLifeComponent } from './daily-life/daily-life.component';
import { LeisureComponent } from './leisure/leisure.component';
import { IgestComponent } from './igest/igest.component';
import { TactographComponent } from './tactograph/tactograph.component';
import { KaviComponent } from './kavi/kavi.component';
import { AditiComponent } from './aditi/aditi.component';
import { TakeNoteComponent } from './take-note/take-note.component';
import { IdrawComponent } from './idraw/idraw.component';
import { VPlayComponent } from './v-play/v-play.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { VbillComponent } from './vbill/vbill.component';
import { PrivacyPolicytakenoteComponent } from './privacy-policytakenote/privacy-policytakenote.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomepageComponent,
    AboutComponent,
    EducomComponent,
    TimelineComponent,
    ContactusComponent,
    EmploymentComponent,
    PageNotFoundComponent,
    CarouselComponent,
    FooterComponent,
    ToolbarComponent,
    MobilityComponent,
    DailyLifeComponent,
    LeisureComponent,
    IgestComponent,
    TactographComponent,
    KaviComponent,
    AditiComponent,
    TakeNoteComponent,
    IdrawComponent,
    VPlayComponent,
    PrivacyPolicyComponent,
    VbillComponent,
    EmploymentComponent,
    PrivacyPolicytakenoteComponent,
  
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot([
      { path:'', component:HomepageComponent },
      { path:'about', component:AboutComponent },
      { path:'educom', component:EducomComponent },
      { path:'timeline', component:TimelineComponent },
      { path:'contactus', component:ContactusComponent },
      { path:'employment', component:EmploymentComponent },
      //{ path: '**', component: PageNotFoundComponent },
      {path:'mob', component:MobilityComponent},
      {path:'dailyLife', component:DailyLifeComponent},
      {path:'leisure', component:LeisureComponent},
      {path:'igest', component:IgestComponent},
      {path:'tactograph', component:TactographComponent},
      {path:'kavi', component:KaviComponent},
      {path:'takeNote', component:TakeNoteComponent},
      {path:'aditi', component:AditiComponent},
      {path:'idraw', component:IdrawComponent},
      {path:'vplay', component:VPlayComponent},
      {path:'vbill', component:VbillComponent},
      {path:'privacyPolicy', component:PrivacyPolicyComponent},
      {path:'privacyPolicyTakenote', component:PrivacyPolicytakenoteComponent}
      
    ], {useHash:true}),
    ReactiveFormsModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts